import { useRef } from 'react';
import { useToast } from '../../../components/ui/use-toast.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { CrmCommentsCreateInput } from '../../../server/queries/crm-comments-create.ts';
import { api } from '../../../utils/api.ts';
import { RichTextForm } from '../../rich-text/components/rich-text-form.tsx';
import type { RichTextValue } from '../../rich-text/components/rich-text-input.tsx';

type NewCommentProps = { taskId: string } | { noteId: string };

export const NewComment = (props: NewCommentProps) => {
    const { t } = useLocale('tasks');
    const { toast } = useToast();
    const containerRef = useRef<HTMLDivElement>(null);

    const apiUtils = api.useUtils();

    const createCommentMutation = api.platoUser.command.comments.create.useMutation({
        onSuccess: (newComment) => {
            apiUtils.platoUser.query.comments.getManyComments.setData(props, (oldData) => {
                if (!oldData) {
                    return [newComment];
                }
                return [...oldData, newComment];
            });
            containerRef.current?.scrollIntoView({ behavior: 'smooth' });
        },
        onError: (error) => {
            toast({
                icon: 'warning',
                title: 'Error',
                description: error.message,
            });
        },
    });

    const handleAddComment = (content: RichTextValue) => {
        const input: CrmCommentsCreateInput = {
            contentRich: content,
            ...props,
        };
        createCommentMutation.mutate(input);
    };

    return (
        <div ref={containerRef}>
            <RichTextForm
                variant="inline"
                placeholder={t('comments__add_placeholder')}
                submitTitle={t('comments__save')}
                onSubmit={handleAddComment}
                isSubmitting={createCommentMutation.isLoading}
            />
        </div>
    );
};
